export default "__VITE_ASSET__CmlEIBeb__"